module.exports = __webpack_public_path__ + "img/063.7e703030.png";